/*
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2024-03-07 15:00:52
 * @FilePath: \js-yigrow-system\src\router\user.js
 * @Description: 
 */

export default [
  {
    path: "/users",
    redirect: "users-list",
  },
  {
    path: "/users/list",
    name: "users-list",
    component: () =>
      import(
        /* webpackChunkName: "users-list" */ "@/views/users/users-page.vue"
      ),
    meta: {
      requiresAuth: true,
      layout: "ui",
      title: "User List",
    },
  },
  {
    path: "/users/edit",
    name: "users-edit",
    component: () =>
      import(
        /* webpackChunkName: "users-edit" */ "@/views/users/edit-user-page.vue"
      ),
    meta: {
      requiresAuth: true,
      layout: "ui",
      title: "Edit User",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/users/profile-page.vue"),
    meta: {
      requiresAuth: true,
      layout: "ui",
      title: "账户中心",
      pertain: "",
    },
  },
  
]
